
export interface BedListing {
  id: string;
  facility_name: string;
  care_level: string;
  waiver_types: string[];
  gender_accepted: string[];
  age_group: string;
  rent_amount: number;
  location: string;
  county: string;
  beds_available: number;
  total_beds: number;
  licensed_capacity: number;
  contact_person: string;
  contact_phone: string;
  contact_email: string;
  description?: string;
  amenities: string[];
  accessibility: string[];
  last_updated: string;
  created_by: string;
  created_at: string;
  clicks: number;
  clicks_reset_date: string;
}

export interface Referral {
  id: string;
  client_age?: number;
  client_gender?: string;
  waiver_type?: string;
  county?: string;
  preferred_locations?: string[];
  budget_range?: string;
  timeline?: string;
  additional_notes?: string;
  referring_user: string;
  linked_listing: string | null;
  status: 'pending' | 'accepted' | 'declined';
  provider_notes?: string;
  created_at: string;
  updated_at: string;
  referral_type?: 'housing_placement' | 'hss_service';
  housing_situation?: string;
  support_needs?: string[];
  context_tags: string[];
  outcome_notes?: string;
  date_initiated: string;
  provider_email?: string;
  provider_name?: string;
}

export const MINNESOTA_COUNTIES = [
  'Aitkin', 'Anoka', 'Becker', 'Beltrami', 'Benton', 'Big Stone', 'Blue Earth', 'Brown', 'Carlton',
  'Carver', 'Cass', 'Chippewa', 'Chisago', 'Clay', 'Clearwater', 'Cook', 'Cottonwood', 'Crow Wing',
  'Dakota', 'Dodge', 'Douglas', 'Faribault', 'Fillmore', 'Freeborn', 'Goodhue', 'Grant', 'Hennepin',
  'Houston', 'Hubbard', 'Isanti', 'Itasca', 'Jackson', 'Kanabec', 'Kandiyohi', 'Kittson', 'Koochiching',
  'Lac qui Parle', 'Lake', 'Lake of the Woods', 'Le Sueur', 'Lincoln', 'Lyon', 'Mahnomen', 'Marshall',
  'Martin', 'McLeod', 'Meeker', 'Mille Lacs', 'Morrison', 'Mower', 'Murray', 'Nicollet', 'Nobles',
  'Norman', 'Olmsted', 'Otter Tail', 'Pennington', 'Pine', 'Pipestone', 'Polk', 'Pope', 'Ramsey',
  'Red Lake', 'Redwood', 'Renville', 'Rice', 'Rock', 'Roseau', 'St. Louis', 'Scott', 'Sherburne', 
  'Sibley', 'Stearns', 'Steele', 'Stevens', 'Swift', 'Todd', 'Traverse', 'Wabasha', 'Wadena',
  'Waseca', 'Washington', 'Watonwan', 'Wilkin', 'Winona', 'Wright', 'Yellow Medicine'
];

export const WAIVER_TYPES = [
  'BI', 'CAC', 'CADI', 'DD', 'EW', 'AC', 'Private Pay', 'Housing Stabilization', 'GRH', 'VA/County', 'None'
];

export const POPULATIONS_SERVED = [
  'Homelessness', 'Mental Health', 'Seniors', 'Substance Use', 'Youth', 'Families', 'Veterans', 'Disabilities'
];

export const HOUSING_SITUATIONS = [
  'Homeless', 'At-risk of homelessness', 'Temporary housing', 'Inadequate housing', 'Other'
];

export const SUPPORT_NEEDS = [
  'Case management', 'Mental health services', 'Substance use treatment', 'Job training', 
  'Financial assistance', 'Healthcare coordination', 'Housing search assistance', 'Life skills training'
];

export const LANGUAGES = [
  'English', 'Spanish', 'Somali', 'Hmong', 'Vietnamese', 'Arabic', 'French', 'German', 'Russian', 'Other'
];

export const PROVIDER_TYPES = [
  { value: 'assisted_living', label: 'Assisted Living Provider' },
  { value: 'hss_agency', label: 'HSS Agency Provider' }
];

export const REFERRAL_TYPES = [
  { value: 'housing_placement', label: 'Housing Placement Referral' },
  { value: 'hss_service', label: 'HSS Service Referral' }
];

export const CARE_LEVELS = [
  'Independent Living', 'Assisted Living', 'Memory Care', 'Skilled Nursing', 'Respite Care', 'Adult Day Care'
];

export const GENDER_OPTIONS = ['Male', 'Female', 'Both'];

export const AGE_GROUPS = ['18+', '55+'];

export const ACCESSIBILITY_OPTIONS = [
  'Accessibility ramp', 'Roll-in shower', 'Railings for stairs'
];
